<template>
  <div>
    <div style="font-size: 14px; color: #606266;">
      <span>Status：{{ formData.v_roleStatus }}</span>
      <el-divider direction="vertical"></el-divider>
      <span
        >Create：{{ formData.createByName }} at {{ formData.createDate }}</span
      >
      <el-divider direction="vertical"></el-divider>
      <span
        >Modify：{{ formData.modifyByName }} at {{ formData.modifyDate }}</span
      >
    </div>
    <div class="mt-2">
      <el-form
        ref="form"
        :model="formData"
        size="medium"
        :rules="rules"
        :disabled="disabled"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_Character_name') || '角色名称'"
              prop="roleName"
            >
              <el-input
                clearable
                v-model="formData.roleName"
                :placeholder="
                  $l('form_label_pe_character_name') || '请输入角色名称'
                "
              >
              </el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item
              :label="
                $l('table_radio_whether_enable_permission') ||
                  '是否启用分类权限'
              "
            >
              <el-col :span="24">
                <el-radio-group v-model="formData.isUseDataRange">
                  <el-radio label="Y">{{
                    $l('table_radio_start_using') || '启用'
                  }}</el-radio>
                  <el-radio label="N">{{
                    $l('table_radio_is_not_enabled') || '不启用'
                  }}</el-radio>
                </el-radio-group>
              </el-col>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
    </div>
    <div class="">
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 18 }" :lg="{ span: 18 }">
          <div class="side-frame-success">
            {{ $l('form_label_role_in_maintaining') || '功能权限' }}
          </div>
          <vxe-grid
            auto-resize
            highlight-hover-row
            ref="roleTreeTable"
            row-id="keyID"
            highlight-current-row
            :data="permissionData"
            :columns="tableColumns"
            :loading="loading"
            :tree-config="{
              childrenField: 'children',
              rowField: 'keyID',
              transform: true,
              parentField: 'pid',
              iconOpen: 'fa fa-caret-down',
              iconClose: 'fa fa-caret-right',
            }"
            :height="showHeight"
            size="small"
            @checkbox-change="checkMenuInfo"
            @checkbox-all="checkAllMenu"
            resizable
            border="default"
          >
            <template v-slot:buttonInfo="{ row }">
              <div v-if="row.buttonList && row.checkButtonList">
                <el-checkbox-group
                  v-model="row.checkButtonList"
                  @change="
                    (value) => {
                      handleCheckedButtonChange(value, row)
                    }
                  "
                >
                  <el-checkbox
                    :label="item.keyID"
                    v-for="item in row.buttonList"
                    :key="item.keyID"
                  >
                    {{ item.titleText }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </template>
          </vxe-grid>
          <!-- <el-card
            shadow="never"
            :style="{
              width: '100%',
              overflowY: 'auto',
              height: showHeight,
            }"
          >
            <el-tree
              :data="permissionData"
              show-checkbox
              default-expand-all
              node-key="keyID"
              ref="tree"
              highlight-current
              :props="defaultProps"
              :empty-text="$l('INDEX.tips_no_data') || '暂无数据！'"
            >
            </el-tree>
          </el-card> -->
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    roleID: String,
  },
  data() {
    return {
      formData: { isUseDataRange: 'N' },
      permissionData: [],
      tableData: [],
      defaultCheckedKeys: [],
      originalCheckedKeys: [],
      defaultProps: {
        children: 'children',
        label: 'titleText',
      },
      loading: false,
      rules: {
        roleName: [
          {
            required: true,
            message:
              this.$l('form_label_pe_character_name') || '请输入角色名称',
            trigger: 'blur',
          },
        ],
      },
      showHeight: '500px',
      tableColumns: [
        {
          field: 'keyID',
          width: 110,
          align: 'left',
          fixed: 'left',
          type: 'checkbox',
          treeNode: true,
        },
        {
          title: '菜单名称',
          field: 'titleText',
          width: 160,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
        },
        {
          title: '功能按钮',
          field: 'menu',
          minWidth: 160,
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: true,
          slots: { default: 'buttonInfo' },
        },
      ],
    }
  },
  created() {
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
  },
  destroyed() {
    window.removeEventListener('resize', this.getHeight)
  },
  mounted() {
    this.getData()
    this.getRoleTreeList()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getHeight() {
      this.showHeight = window.innerHeight - 376 + 'px'
    },
    getData() {
      if (!this.roleID) return
      this.$api
        .sysRoleDetailApi({
          roleID: this.roleID,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    handleCheckedButtonChange(value, row) {
      if (value.length > 0) {
        this.$nextTick(() => {
          this.$refs.roleTreeTable.setCheckboxRow([row], true)
        })
      } else {
        this.$nextTick(() => {
          this.$refs.roleTreeTable.setCheckboxRow([row], false)
        })
      }
    },
    checkAllMenu({ checked }) {
      if (checked) {
        this.checkedButton(this.permissionData)
      } else {
        this.clearCheckButton(this.permissionData)
      }
    },
    checkMenuInfo({ checked, row }) {
      if (checked) {
        this.checkedButton([row])
      } else {
        this.clearCheckButton([row])
      }
    },
    getRoleTreeList() {
      let params = { roleID: this.roleID ? this.roleID : '00' }
      this.loading = true
      this.$api
        .sysRoleTreeApi(params)
        .then((res) => {
          const { data } = res.body
          this.loadRoleTree(data)
          this.permissionData = data
          this.tableData = cloneDeep(data) 
          this.$nextTick(() => {
            this.$refs.roleTreeTable.setCheckboxRow(
              this.defaultCheckedKeys,
              true
            )
          })
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    loadRoleTree(data) {
      if (!this.roleID) {
        this.clearCheckButton(data)
        return
      }

      let len = data.length
      if (!len) return
      for (let i = 0; i < len; i++) {
        data[i].disabled = this.disabled
        if (data[i].children != null) {
          this.loadRoleTree(data[i].children)
        } else {
          if (data[i].permission === 'Y') {
            this.defaultCheckedKeys.push(data[i])
          }
        }
      }
    },
    checkedButton(data) {
      let len = data.length
      if (!len) return
      for (let i = 0; i < len; i++) {
        data[i].disabled = this.disabled
        if (data[i].children != null && data[i].children.length > 0) {
          this.checkedButton(data[i].children)
        } else {
          data[i].checkButtonList = (data[i].buttonList || []).map(
            (e) => e.keyID
          )
        }
      }
    },
    clearCheckButton(data) {
      let len = data.length
      if (!len) return
      for (let i = 0; i < len; i++) {
        data[i].disabled = this.disabled
        if (data[i].children != null && data[i].children.length > 0) {
          this.clearCheckButton(data[i].children)
        } else {
          data[i].checkButtonList = []
        }
      }
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      let checkRows = this.$refs.roleTreeTable.getCheckboxRecords(true) || []
      let indeterminate = this.$refs.roleTreeTable.getCheckboxIndeterminateRecords()
      let roleAuth = checkRows.map((e) => e.keyID)
      if (indeterminate.length > 0) {
        for (let i = 0; i < indeterminate.length; i++) {
          roleAuth.push(indeterminate[i].keyID)
        }
      }
      for (let i = 0; i < checkRows.length; i++) {
        const tmpCheckButtonList = checkRows[i].checkButtonList || []
        roleAuth = roleAuth.concat(tmpCheckButtonList)
      }
      // let selectRole = this.$refs.tree.getCheckedKeys()
      // let selectRoleHalf = this.$refs.tree.getHalfCheckedKeys()
      // if (selectRoleHalf.length > 0) {
      //   for (let i = 0; i < selectRoleHalf.length; i++) {
      //     selectRole.push(selectRoleHalf[i])
      //   }
      // }
      this.getUpdateData(this.tableData)
      this.loadingOpen()
      this.$api
        .sysRoleSaveApi({
          ...this.formData,
          roleAuth,
          change:
            roleAuth.sort().toString() !=
            this.originalCheckedKeys.sort().toString(),
        })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.saveOkQuestion()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    getUpdateData(data) {
      if (!this.roleID) return
      let len = data.length
      if (!len) return
      for (let i = 0; i < len; i++) {
        if (data[i].permission === 'Y') {
          this.originalCheckedKeys.push(data[i].keyID)
        }
        const { checkButtonList } = data[i]
        if (checkButtonList != null && checkButtonList.length > 0) {
          this.originalCheckedKeys = this.originalCheckedKeys.concat(
            checkButtonList
          )
        }
        if (data[i].children != null) {
          this.getUpdateData(data[i].children)
        }
      }
      this.originalCheckedKeys = Array.from(new Set(this.originalCheckedKeys))
    },
    saveOkQuestion() {
      this.$alert(
        this.$l('form_label_permission_save') || '角色权限数据保存成功',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          callback: () => {
            // this.$eventBus.$emit('roleSaveSuccess')
            this.closeCurPage()
          },
        }
      )
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.role-tree::-webkit-scrollbar {
  width: 13px;
}
.role-tree::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}
.role-tree::-webkit-scrollbar-thumb {
  background: #ababab;
  border-radius: 3px;
}
.role-tree::-webkit-scrollbar-thumb:hover {
  background: #ababab;
}
</style>
